// Basado en el Analizador Cabrillo original de XQ2OP.
// Utilidades de dominio (banda, indicativo, locator) extraídas sin
// cambios algorítmicos del bloque //PURE-START..//PURE-END de
// public/cabrillo/src/plantilla.html. Ver src/cabrillo/CREDITOS.md.
//
// Deliberadamente independientes del formato Cabrillo: son las que
// reutilizaría un futuro parser ADIF u otro formato de log.

import { BR } from './constantes.js';

/** Frecuencia (string, kHz) → nombre de banda. */
export function bandOf(s) {
    const f = parseFloat(s);
    if (isNaN(f)) return String(s).toUpperCase();
    if (f < 1000) {
        const m = { 50: '6', 144: '2', 222: '1.25', 432: '70cm', 902: '33cm' };
        return m[Math.round(f)] || '?';
    }
    for (const [a, b, n] of BR) if (f >= a && f <= b) return n;
    return '?';
}

/** Clave de orden (longitud de onda aproximada) para ordenar bandas. */
export const wl = (b) => (b == '70cm' ? 0.7 : b == '33cm' ? 0.33 : parseFloat(b) || 0);

/** Etiqueta legible de banda ("20" → "20 m"). */
export const bl = (b) => (/^[\d.]+$/.test(b) ? b + ' m' : b);

/**
 * Indicativo → [countryId, zonaCQ], usando la tabla CTY (CT.e = excepciones
 * exactas, CT.p = prefijos). Maneja indicativos portables (ej. "/P", "/MM").
 * @param {string} c - indicativo
 * @param {{e: object, p: object, c: Array}} CT - tabla CTY (ver datos.js)
 */
export function look(c, CT) {
    c = c.toUpperCase();
    if (CT.e[c]) return CT.e[c];
    let b = c;
    if (c.includes('/')) {
        const ps = c.split('/').filter((x) => x && !/^(P|M|MM|AM|QRP|A|B|\d)$/.test(x));
        b = !ps.length
            ? c.split('/')[0]
            : ps.length == 2 && ps[0].length < ps[1].length && ps[0].length <= 4
                ? ps[0]
                : ps.reduce((a, x) => (x.length > a.length ? x : a));
    }
    for (let n = b.length; n > 0; n--) {
        const v = CT.p[b.slice(0, n)];
        if (v) return v;
    }
    return null;
}

/** Heurística: ¿este token parece un indicativo de radioaficionado? */
export const isCall = (k) =>
    /^(?=.*[A-Z])(?=.*\d)[A-Z0-9\/]{3,14}$/.test(k) && !/^[1-5][1-9N]{1,2}$/.test(k);

/** Locator Maidenhead (4 o 6 caracteres) → [lat, lon]. */
export function grid(g) {
    g = (g || '').toUpperCase();
    if (!/^[A-R]{2}\d\d([A-X]{2})?$/.test(g)) return null;
    const n = g.length > 4;
    return [
        -90 + (g.charCodeAt(1) - 65) * 10 + +g[3] + (n ? (g.charCodeAt(5) - 65) / 24 + 1 / 48 : 0.5),
        -180 + (g.charCodeAt(0) - 65) * 20 + +g[2] * 2 + (n ? (g.charCodeAt(4) - 65) / 12 + 1 / 24 : 1),
    ];
}
